<p-dialog class="flex-wrap" (onHide)="hiddeDialog()" [header]="title()"
          [(visible)]="visible" [closable]="true" [modal]="true"
          [breakpoints]="{ '960px': '75vw' }" [style]="{ width: '60vw' }" [draggable]="false"
          [resizable]="false" closeIcon="pi pi-times loading-icon-size">
    <ng-template pTemplate="header">
        <div class="flex flex-col gap-2">
            <div class="flex items-center gap-2">
                <i class="pi pi-tags text-blue-500 text-2xl"></i>
                <span class="white-space-nowrap">{{ title() }}</span>
            </div>
        </div>
    </ng-template>
    <ng-template pTemplate="content">
        <p-messages severity="error" *ngIf="tramitesPorProyecto.length === 0">
            <ng-template pTemplate>
                <div class="flex flex-col gap-2 text-xl">
                    La solicitud no contiene trámite individual para el servicio exprés
                    <span class="font-bold text-base"></span>
                </div>
            </ng-template>
        </p-messages>
        <p-messages severity="warn" *ngIf="tramitesPorProyecto.length > 0 && datosCargados">
            <ng-template pTemplate>
                <div class="flex flex-col gap-2 text-xl">
                    Selecciona el trámite individual para el servicio exprés
                    <span class="font-bold text-base"></span>
                </div>
            </ng-template>
        </p-messages>
        <div *ngIf="datosCargados; else loading">
            <p-table [paginator]="true" [rows]="10" [showCurrentPageReport]="true" responsiveLayout="stack"
                     currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} trámites asignados"
                     [rowsPerPageOptions]="[10, 25, 50]" [resizableColumns]="false" columnResizeMode="expand"
                     styleClass="p-datatable-gridlines" [tableStyle]="{ 'min-width': '50rem' }" [value]="tramitesPorProyecto">
                <ng-template pTemplate="header">
                    <tr>
                        <th style="width:35%">Nombre</th>
                        <th style="width:15%">Fase</th>
                        <th style="width:10%">Tarífa</th>
                        <th style="width:25%">Estado</th>
                        <th style="width:5%">Opción</th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-tramite>
                    <tr>
                        <td>
                            <div class="flex align-items-center">
                                <span>{{ tramite.idTramite }} - {{ tramite.nombreTramite }}</span>
                            </div>
                            <app-tag-informativo-tramite-expres [tramite]="tramite"></app-tag-informativo-tramite-expres>
                        </td>
                        <td>{{ tramite.nombreFase }}</td>
                        <td>
                            {{ tramite.tarifaTramite | currency:'USD':'symbol':'1.2-2' }}
                        </td>
                        <td>
                            <p-tag *ngIf="tramite.tramiteEstado&&tramite.tramiteEstado.codigoEstado!=0"
                                   [style]="{ 'background':tramite.tramiteEstado.color}">
                                <div class="flex align-items-center gap-2">
                                    <i class="pi pi-tags text-xs"></i>
                                    <span class="text-base">{{ tramite.tramiteEstado?.nombreEstado }}</span>

                                </div>
                            </p-tag>
                        </td>
                        <td>
                            <div class="md:col-4">
                                <p-checkbox *ngIf="tramite?.idEstadoTramite === EstadoTramiteEnum.FormularioCompleto && tramite.idCategoria != CategoriaTramiteEnum.ServicioOnlineExpresporTramiteIntegrado" [binary]="true" (onChange)="onCheckboxChange($event, tramite)"
                                            [inputId]="tramite.idTramite.toString()"
                                            [disabled]="onCheckboxDisabled(tramite)"
                                            [pTooltip]="'Seleccionar el trámite individual para el servicio exprés'"
                                            [ngModel]="isProyectoSeleccionado(tramite.idTramite)">
                                </p-checkbox>
                            </div>
                            <div *ngIf="mostrarInfoIcon(tramite)" class="md:col-4">
                                <span
                                    (click)="overlay.toggle($event)" [pTooltip]="'Clic para ver información'"
                                    class="pi pi-info-circle text-2xl"
                                    style="cursor: pointer"
                                ></span>
                                <p-overlayPanel #overlay appendTo="body" [style]="{ width: '250px' }" my="left top" at="right top">
                                    <span><b>Criterios de selección</b></span>
                                    <ul style="margin: 0; padding-left: 1rem;">
                                        <li>Solo se puede seleccionar un trámite en estado "Formulario completo"</li>
                                        <li>No se puede seleccionar más de un trámite al mismo tiempo</li>
                                        <li>No se puede seleccionar un trámite que ya posea un servicio expres incorporado</li>
                                    </ul>
                                </p-overlayPanel>
                            </div>
                        </td>
                    </tr>
                </ng-template>
            </p-table>
        </div>
    </ng-template>
    <ng-template pTemplate="footer">
        <button pButton pRipple label="Cancelar" icon="pi pi-times" class="p-button-text"
                (click)="hiddeDialog()"></button>
        <button pButton pRipple [label]="'Procesar'" icon="pi pi-check" [pTooltip]="'El trámite seleccionado se le aplicará la tarifa correspondiente al servicio exprés'"
                class="p-button-text" (click)="procesarTramiteExpress()" [disabled]="tramiteService.tramiteItemSeletected().length == 0"></button>
    </ng-template>
   <ng-template #loading class="flex align-items-center flex-wrap">
        <div class="flex justify-content-center flex-wrap">
            <p-progressSpinner></p-progressSpinner>
        </div>
    </ng-template>
</p-dialog>
